"use client";

import { getTranslation } from "@/i18n/get-translation";
import FAQ from "@components/faq/faq";

interface IHomeFAQs {
  locale: string;
}
export default function HomeFAQs({ locale }: IHomeFAQs) {
  const t = getTranslation(locale, "faqs");
  return (
    <section
      id="faq"
      className="relative text-center px-20 pt-14 pb-14 max-md:px-7"
    >
      <div className="flex text-left items-center max-w-392 lg:gap-5 mx-auto max-md:flex-wrap max-md:max-w-full">
        <div className="basis-2/4 pl-28.5 max-l:pl-0 max-md:basis-full">
          <div className="relative max-w-141 max-md:max-w-full max-md:mb-9">
            <div className="bg-(image:--circle-gradient) h-56 w-56 rounded-full rotate-45 absolute top-6 left-4 -translate-1/2 -z-10 max-md:hidden"></div>
            <p className="text-2xl text-secondary-800 mb-5 max-md:text-lg">
              {t("faqsTitle")}
            </p>
            <h2 className="xl:text-[3rem] lg:text-[2.5rem] md:text-[2.2rem] text-[1.88rem] leading-none font-medium mx-auto text-primary-800">
              {t("answersToYourQuestions")}
            </h2>
            <p className="mt-6 text-primary-600 xl:text-xl lg:text-lg text-base font-light">{t("faqsDescription")}</p>
            <div className="flex mt-6">
              <a
                href={`/${locale}/faqs`}
                className="whitespace-nowrap border-[0.063rem] border-primary-700 text-primary-700 font-medium rounded-full py-4 h-[3.5rem] leading-4 flex items-center px-7"
                aria-label="View more frequently asked questions"
              >
                {t("viewMore")}
              </a>
            </div>
          </div>
        </div>
        <div className="basis-2/4 max-md:basis-full">
          <div className="max-w-160 max-md:max-w-full">
            <FAQ displayCount={6} locale={locale} />
          </div>
        </div>
      </div>
    </section>
  );
}
